import styled, { createGlobalStyle, css } from 'styled-components'
import { color } from 'ui/themes/utils'

import H3 from 'ui/elements/H3'
import P from 'ui/elements/P'
import Div from 'ui/elements/Div'
import Label from 'ui/elements/Label'

export const HostStyles = createGlobalStyle`
  :host {
    --services-container-background: transparent;
    --services-container-padding: 16px;
    --services-container-border-radius: 8px;
    --services-container-border: 1px solid var(--color-border, ${color('Misc/Divider')});

    --services-text-color: var(--color-primary-foreground, ${color('Text/Primary')});

    --service-checkbox-border: 1px solid var(--color-border, ${color('Misc/Divider')});
    --service-checkbox-border-radius: 4px;
    --service-checkbox-size: 20px;
    --service-checkbox-color: ${color('white')};
    --service-checkbox-color-checked: var(--color-accent-background, ${color('branding')});
    --service-checkbox-icon-color: var(--color-accent-foreground, ${color('white')});

    --service-title-font-size: 18px;
    --service-name-font-size: 16px;
    --service-price-font-size: 16px;
  }

  * {
    box-sizing: border-box;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`

export const Container = styled(Div)`
  position: relative;

  background: var(--services-container-background);
  border: var(--services-container-border);

  padding: var(--services-container-padding);

  border-radius: var(--services-container-border-radius);
`

export const Title = styled(H3)`
  font-family: var(--font-body);
  font-weight: 600;
  font-size: var(--service-title-font-size);

  margin-bottom: 14px;

  color: var(--services-text-color);
`

export const ServiceContainer = styled(Div)`
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 12px;

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  ${({ hasPrice }) =>
    hasPrice &&
    css`
      grid-template-columns: max-content 1fr max-content;
    `}

  ${({ loading }) =>
    loading &&
    css`
      grid-template-columns: max-content 1fr max-content;
    `}
`

export const Name = styled(Div)`
  display: flex;
  align-items: center;

  ${Label} {
    font-family: var(--font-body);
    font-size: var(--service-name-font-size);
    font-weight: 400;

    cursor: pointer;

    margin: 0;

    color: var(--services-text-color);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.7;
    `}
`

export const Checkbox = styled(Div)`
  width: var(--service-checkbox-size);
  height: var(--service-checkbox-size);

  cursor: pointer;

  border-radius: var(--service-checkbox-border-radius);
  border: var(--service-checkbox-border);

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2px;

  background-color: var(--service-checkbox-color);

  svg {
    max-width: 100%;
    max-height: 100%;

    width: 100%;

    color: var(--service-checkbox-icon-color);
    fill: var(--service-checkbox-icon-color);

    visibility: hidden;
  }
`

export const CheckboxContainer = styled(Div)`
  position: relative;

  & > input[type='checkbox'] {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    visibility: hidden;

    &:checked + ${Checkbox} {
      background-color: var(--service-checkbox-color-checked);

      svg {
        visibility: visible;
      }
    }
  }
`

export const Price = styled(P)`
  font-family: var(--font-body);
  font-weight: 700;
  font-size: var(--service-price-font-size);

  color: var(--services-text-color);

  text-align: right;

  margin: 0;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.7;
    `}
`
